var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.444,
    height: 18.558,
    viewBox: "0 0 11.444 18.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff9017;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-1",
    d: "M11.444,2.165,4.33,9.279l7.114,7.114L9.279,18.558,0,9.279,9.279,0Z",
    transform: "translate(11.444 18.558) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7b54b9eb1847ebafd906f86c8c78f546.svg";
export { ForwardRef as ReactComponent };